import React from 'react';
import Stack from '@mui/material/Stack';

import { MessageCenterDetails } from 'src/features/message-center';
import { MessageCenterList } from 'src/features/message-center';
import {
  MessageCenterEditProvider,
  MessageCenterQueryProvider,
  MessageCenterSelectionProvider,
} from 'src/features/message-center/providers';

export const MessageCenterPage = () => {
  return (
    <div id="page-wrapper">
      <Stack direction="row" height="100%" gap={4}>
        <MessageCenterQueryProvider>
          <MessageCenterEditProvider>
            <MessageCenterSelectionProvider>
              <Stack flex={2} minHeight={0}>
                <MessageCenterList />
              </Stack>
              <Stack flex={3} mt={8}>
                <MessageCenterDetails />
              </Stack>
            </MessageCenterSelectionProvider>
          </MessageCenterEditProvider>
        </MessageCenterQueryProvider>
      </Stack>
    </div>
  );
};
